import { createContext } from "react";

const DndControllerContext = createContext();

export default DndControllerContext;